<template>
  <div>
    Connection Lost
  </div>
</template>

<script setup></script>
